/**
 * フィルター有無で切り替わるページネーションを計算する。
 * フィルター使用時: rows をクライアントでスライスし、件数も rows.length ベース。
 * フィルター未使用時: rows をそのまま表示し、totalPages は serverTotal ベース。
 */
export function useFilteredPagination<T>({
  hasActiveFilter,
  rows,
  serverTotal,
  currentPage,
  perPage,
}: {
  hasActiveFilter: boolean;
  rows: T[];
  serverTotal: number;
  currentPage: number;
  perPage: number;
}): { paginatedRows: T[]; totalPages: number } {
  const totalPages = Math.max(
    1,
    hasActiveFilter
      ? Math.ceil(rows.length / perPage)
      : Math.ceil(Math.max(0, serverTotal) / perPage)
  );
  const paginatedRows = hasActiveFilter
    ? rows.slice((currentPage - 1) * perPage, currentPage * perPage)
    : rows;
  return { paginatedRows, totalPages };
}
